import AlertMessage from "src/components/ui-components/AlertMessage";
import axios from "src/lib/axios";

const API_URLS = {
  SEND_OTP: `/Account/SendOTP`,
  CHANGE_PASSWORD: `/Account/ChangeMobileUserPassword`,
  PASSWORD_STATUS: `/Users/CheckUserPasswordStatus`
};

export const SendOTP = async (data: { appKey: string; username: string; otpReason: string }): Promise<any> => {
  try {
    const res = await axios.post(API_URLS.SEND_OTP, data);
    AlertMessage({ type: res.data.isSuccess ? 'success' : 'error', msg: res?.data?.message });
    return res?.data?.isSuccess;
  } catch (err) {
    Object.entries(err.errors).forEach(([, errMsg]: any) => {
      AlertMessage({ type: 'error', msg: errMsg.errorMessage });
    });
    return false;
  }
};

export const ChangeMobileUserPassword = async (data: {
  appKey: string;
  username: string;
  otp: string;
  password: string;
  updateReason: string;
}): Promise<any> => {
  try {
    const res = await axios.post(API_URLS.CHANGE_PASSWORD, data);
    AlertMessage({ type: res.data.isSuccess ? "success" : "error", msg: res?.data?.message });
    return res?.data;
  } catch (err) {
    if (err.errors) {
      Object.entries(err.errors).forEach(([, errMsg]: any) => {
        AlertMessage({ type: "error", msg: errMsg.errorMessage });
      });
    } else {
      AlertMessage({ type: "error", msg: "An unexpected error occurred. Please try again." });
    }
    return { isSuccess: false, message: "Failed to change password" };
  }
};

export const CheckUserPasswordStatus = async (username: string, appKey: string): Promise<any> => {
  try {
    const url = `${API_URLS.PASSWORD_STATUS}?username=${username}&appKey=${appKey}`;
    
    const res = await axios.get(url);
    return res?.data;
  } catch (err) {
    Object.entries(err.errors || {}).forEach(([, errMsg]: any) => {
      AlertMessage({ type: 'error', msg: errMsg.errorMessage });
    });
    return false;
  }
};